export const configuracoesEstiloBtnAcao = {
    edicao: { icon:'pi pi-erase',
        cssClass: 'p-button-danger' },
    cadastro: { icon:'pi pi-plus',
        cssClass: 'p-button-primary' }
};